export default "__VITE_ASSET__GHK7LO$h__"